exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Photos_ExpandedPhotoDialog_Caption{font-size:12px;color:#fff;background:#000;outline:0;border:0}.Photos_ExpandedPhotoDialog_Caption:active,.Photos_ExpandedPhotoDialog_Caption:focus,.Photos_ExpandedPhotoDialog_Caption:hover{text-decoration:none;border:0;outline:0}.Photos_ExpandedPhotoDialog_Caption .Photos_ExpandedPhotoDialog_UploadedAt{font-size:11px;color:#959595;text-align:left;font-weight:400;padding:0 5px 5px}.Photos_ExpandedPhotoDialog_Caption .Photos_ExpandedPhotoDialog_CaptionText{text-align:left;border-top:1px solid #fff;margin:0 0 5px;font-weight:lighter;padding:5px 5px 0}", ""]);

// exports
